import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { type RespondedWith, responseScheme } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const generateRegistrationDataByCodeQueryOptions = (code: Nullable<string>) =>
  queryOptions({
    queryKey: ['/GetRegisterCodeData', code],
    queryFn: code
      ? ({ signal }) =>
          fetcher<RespondedWith<string>>(
            '/GetRegisterCodeData',
            { Data: code },
            { signal, schema: responseScheme.extend({ Data: z.string() }), validResponseCodes: [0] },
          ).then((response) => response?.Data ?? null)
      : skipToken,
    refetchOnWindowFocus: false,
  });

export default function useRegistrationDataByCode(code: Nullable<string>) {
  return useQuery(generateRegistrationDataByCodeQueryOptions(code));
}
